import React from 'react'
import './FileModalPopup.css'
import img01 from './assets/File.svg'

const FileModalPopup = props => (
  <div className={`File-modal File-modal-popup File-modal-${props.name}`}>
    <div className="File-modal-content">
      {props.children}
    </div>
    <div className="File-modal-underlay" style={{ backgroundImage: `url(${img01})`}}/>
    <div className="File-modal-overlay" />
  </div>
)

export default FileModalPopup
